import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { Injectable } from '@angular/core';

export interface RouteMetadata {
  title?: string;
  description?: string;
  keywords?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MetadataTitleResolver implements Resolve<boolean> {
  constructor(
    private readonly titleService: Title,
    private readonly metaService: Meta
  ) {
    metaService.addTag({ property: 'og:image', content: 'assets/drift-logo-1.png' });
    metaService.addTag({ property: 'twitter:image', content: 'assets/drift-logo-1.png' });
  }

  resolve(route: ActivatedRouteSnapshot): boolean {
    const metadata: RouteMetadata = route.data['meta'] as RouteMetadata;

    this.updateTitle(metadata);
    this.updateMetadata(metadata);

    return true;
  }

  private updateTitle(metadata: RouteMetadata): void {
    if (metadata.title) {
      const fullTitle = `${metadata.title}` || 'DRIFT';
      this.titleService.setTitle(fullTitle);
    }
  }

  private updateMetadata(metadata: RouteMetadata): void {
    const tagsToRemove = [
      'name="description"',
      'name="keywords"',
      'property="og:title"',
      'property="og:description"',
      'name="twitter:card"',
      'name="twitter:title"',
      'name="twitter:description"'
    ];
    tagsToRemove.forEach(selector => this.metaService.removeTag(selector));

    if (metadata.description) {
      this.metaService.addTag({ name: 'description', content: metadata.description });
    }
    if (metadata.keywords) {
      this.metaService.addTag({ name: 'keywords', content: metadata.keywords });
    }

    if (metadata.title) {
      this.metaService.addTag({ property: 'og:title', content: metadata.title });
    }
    if (metadata.description) {
      this.metaService.addTag({ property: 'og:description', content: metadata.description });
    }

    if (metadata.title) {
      this.metaService.addTag({ name: 'twitter:card', content: 'summary' });
    }

    if (metadata.title) {
      this.metaService.addTag({ name: 'twitter:title', content: metadata.title });
    }
    if (metadata.description) {
      this.metaService.addTag({ name: 'twitter:description', content: metadata.description });
    }
  }
}
